import script from "./Intents.vue?vue&type=script&lang=ts&setup=true"
export * from "./Intents.vue?vue&type=script&lang=ts&setup=true"

import "./Intents.vue?vue&type=style&index=0&id=b1578a7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1578a7c"]])

export default __exports__